import { render, staticRenderFns } from "./InspectionCriteria4a.vue?vue&type=template&id=14bbfd7e&scoped=true"
import script from "./InspectionCriteria4a.vue?vue&type=script&lang=ts"
export * from "./InspectionCriteria4a.vue?vue&type=script&lang=ts"
import style0 from "./InspectionCriteria4a.vue?vue&type=style&index=0&id=14bbfd7e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14bbfd7e",
  null
  
)

export default component.exports